import { render } from "./SearchPopupComponent.vue?vue&type=template&id=21070820&scoped=true"
import script from "./SearchPopupComponent.vue?vue&type=script&lang=js"
export * from "./SearchPopupComponent.vue?vue&type=script&lang=js"

import "./SearchPopupComponent.vue?vue&type=style&index=0&id=21070820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21070820"]])

export default __exports__